var map = {
	"./alabo/pc/part4/unexpansion/character1.png": 929,
	"./alabo/pc/part4/unexpansion/character2.png": 35,
	"./alabo/pc/part4/unexpansion/character3.png": 8653,
	"./alabo/pc/part4/unexpansion/character4.png": 1895,
	"./alabo/pc/part4/unexpansion/character5.png": 7645,
	"./alabo/pc/part4/unexpansion/character6.png": 2146,
	"./alabo/pc/part4/unexpansion/character7.png": 85,
	"./alabo/pc/part4/unexpansion/character8.png": 1363,
	"./english/pc/part4/unexpansion/character1.png": 5424,
	"./english/pc/part4/unexpansion/character2.png": 6338,
	"./english/pc/part4/unexpansion/character3.png": 1173,
	"./english/pc/part4/unexpansion/character4.png": 3845,
	"./english/pc/part4/unexpansion/character5.png": 9182,
	"./english/pc/part4/unexpansion/character6.png": 6284,
	"./english/pc/part4/unexpansion/character7.png": 1079,
	"./english/pc/part4/unexpansion/character8.png": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7026;